module.exports = __webpack_public_path__ + "img/img3.caa64515.jpg";